import React from 'react';
import { Helmet } from '@sm/webassets';
import { HelmetProps } from './types';

/**
 *  To appease TS and extend Helmet which does not accept direct JSX.Element component instead as a function,
 *  This wrapper is needed to extend the basic Helmet component to accept children as optional
 *  See this thread  https://github.com/nfl/react-helmet/issues/646#issuecomment-1398700719
 */

export default function HelmetWithChildren({ children, ...rest }: HelmetProps): JSX.Element {
  return <Helmet {...rest}>{children}</Helmet>;
}
